// SSR-safe wrappers around the auth-token slot in localStorage.
//
// The vite-react-ssg crawler renders pages in Node, where `localStorage`
// doesn't exist. Any module-level or render-time access blows up the
// build (see RootLayout → Layout → Navbar → useCurrentUser path). Read
// access goes through `getAuthToken()` so the same React code can run
// in both environments and the SSR pass simply sees "no token". Write
// access through `setAuthToken/clearAuthToken` keeps the symmetry,
// even though the writers always run client-side (mutation callbacks).

const TOKEN_KEY = 'auth_token'

export function getAuthToken(): string | null {
  if (typeof window === 'undefined') return null
  return window.localStorage.getItem(TOKEN_KEY)
}

export function hasAuthToken(): boolean {
  return !!getAuthToken()
}

export function setAuthToken(token: string): void {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(TOKEN_KEY, token)
}

export function clearAuthToken(): void {
  if (typeof window === 'undefined') return
  window.localStorage.removeItem(TOKEN_KEY)
}
